import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "eb-header" }
const _hoisted_2 = { class: "eb-title" }
const _hoisted_3 = {
  key: 0,
  class: "eb-actions"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pen_icon = _resolveComponent("pen-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_tick_icon = _resolveComponent("tick-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["editable-block", {'remove-block-style': _ctx.removeBlockStyle, 'remove-scope-style': _ctx.removeScopeStyle}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.title)
          ? _renderSlot(_ctx.$slots, "title", {
              key: 0,
              title: _ctx.title
            }, () => [
              _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1)
            ], true)
          : _createCommentVNode("", true)
      ]),
      (!_ctx.readonly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "actions", _normalizeProps(_guardReactiveProps({ editingRef: _ctx.editingRef, cancel: _ctx.cancel, save: _ctx.save })), () => [
              (!_ctx.editingRef.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_q_btn, {
                      unelevated: "",
                      rounded: "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editingRef.value = true)),
                      outline: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_pen_icon, { left: "" }),
                        _cache[1] || (_cache[1] = _createElementVNode("span", null, "Edit", -1))
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_q_btn, {
                      class: "q-mr-md",
                      unelevated: "",
                      rounded: "",
                      onClick: _ctx.cancel
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_close_icon, { left: "" }),
                        _cache[2] || (_cache[2] = _createElementVNode("span", null, "Cancel", -1))
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_q_btn, {
                      unelevated: "",
                      rounded: "",
                      color: "primary",
                      onClick: _ctx.save
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_tick_icon, { left: "" }),
                        _cache[3] || (_cache[3] = _createElementVNode("span", null, "Save", -1))
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
            ], true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["eb-content", [ _ctx.layout ]])
    }, [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ editState: _ctx.editState, editingRef: _ctx.editingRef, save: _ctx.save })), undefined, true)
    ], 2)
  ], 2))
}